module.exports = __webpack_public_path__ + "img/[抓狂备份].dc9797f1.svg";